'use client';

import { useTravelConfig } from '@/hooks/useTravelConfig';
import { memo } from 'react';

interface LiveClockProps {
  className?: string;
}

export const LiveClock = memo(({ className = '' }: LiveClockProps) => {
  const { timeData, isLoading, error } = useTravelConfig();

  if (isLoading) {
    return (
      <span className={`text-sm ${className}`}>
        ⏰ Loading...
      </span>
    );
  }

  if (error || !timeData) {
    return (
      <span className={`text-sm text-red-400 ${className}`}>
        ⏰ Unable to load time
      </span>
    );
  }

  return (
    <span
      className={`text-sm font-mono ${className}`}
      role="status"
      aria-label={`Current date and time: ${timeData.dateString}, ${timeData.timeString} ${timeData.utcOffset} in ${timeData.location.city}, ${timeData.location.country}`}
    >
      ⏰ {timeData.dateString} • {timeData.timeString} ({timeData.utcOffset})
    </span>
  );
});

LiveClock.displayName = 'LiveClock';
